import { observer } from 'mobx-react'

import companies from 'modules/core/store/collections/companies'

import { companySubscription } from 'modules/billing/store/collections/subscriptions'
import { getTrialRemainingDays } from 'modules/onboarding/lib/trialDays'

import UpgradeBanner from './UpgradeBanner'

const TrialBanner = () => {
  const company = companies.current
  const subscription = companySubscription(company)

  if (!subscription) return null

  const dayCount = getTrialRemainingDays(subscription)

  return <UpgradeBanner dayCount={dayCount} />
}

export default observer(TrialBanner)
